import { type LoaderData, type LoaderFunction, json, useLoaderData, wordpressLoader, useNavigation } from '@ubo/losse-sjedel'
import { useEffect } from 'react'
import progress from 'nprogress'
import FlexContentHandler from '~/components/flex/FlexContentHandler'
import Layout from '~/components/layout/Layout'
import { replaceWordpressUrl } from '~/utils/wordpressUrl.server'

export const loader: LoaderFunction = async (args) => {
  const { body, headers } = await wordpressLoader(args)

  return json(replaceWordpressUrl(body, args.request), headers)
}

export default function $page() {
  const {
    page: { contentType, flexContent }
  } = useLoaderData<LoaderData>()

  const transition = useNavigation()

  useEffect(() => {
    if (transition.state === 'loading' || transition.state === 'submitting') {
      progress.start()
    } else {
      progress.done()
    }
  }, [transition.state])

  return (
    <Layout>
      <FlexContentHandler prefix={`${contentType?.node?.name}_Flexcontent`} flex={flexContent?.flex as any} />
    </Layout>
  )
}
